module.exports = __webpack_public_path__ + "static/img/9.5072d14d.png";